// Add here the polyfills needed for legacy browsers
// See the list in package.json > browserslist > legacy
// Or list targeted browsers with `npx browserslist --env="legacy"`

import 'whatwg-fetch';
import 'mdn-polyfills/String.prototype.includes';

import objectFitImages from 'object-fit-images';

objectFitImages();
